module.exports = __webpack_public_path__ + "08_hige_black.7709a984.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer3/08_hige_black.png
// module id = aAHq
// module chunks = 0